$(document).ready(function () {
    const tables = [
        {
            selector: '#property-stock-movements-table',
            columns: [
                { data: 'date', name: 'effective_date' },
                { data: 'type', name: 'type' },
                { data: 'subject', name: 'item_name' },
                { data: 'quantity', name: 'quantity_delta' },
                { data: 'status', name: 'status' },
                { data: 'actions', orderable: false, searchable: false, className: 'text-nowrap text-center table-col-actions' }
            ]
        }
    ];

    const balances = $('#property-stock-balances-table');
    if (balances.length) window.initStockBalanceTable(balances, false);

    tables.forEach(function (config) {
        const table = $(config.selector);
        if (!table.length) return;

        table.DataTable({
            processing: true,
            serverSide: true,
            pageLength: 25,
            searchDelay: 350,
            order: [],
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
            ajax: table.data('url'),
            columns: config.columns,
            language: window.dataTablesRussianLanguage
        });
    });

    const $propertyPrintBtn = $('#property-stock-balances-print-btn');
    if ($propertyPrintBtn.length) {
        $propertyPrintBtn.on('click', function () {
            const table = $('#property-stock-balances-table').DataTable();
            const searchVal = table ? table.search() : '';
            const baseUrl = $propertyPrintBtn.attr('href').split('?')[0];
            const params = new URLSearchParams();
            if (searchVal) {
                params.set('search', searchVal);
            }
            const queryString = params.toString();
            $propertyPrintBtn.attr('href', baseUrl + (queryString ? '?' + queryString : ''));
        });
    }
});
